export const RETRIEVE_WEIGHTS = 'commercial/weights/retrieve';

export const RETRIEVE_WEIGHT = 'commercial/weights/getById';
